import React, { useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import dashboardBanner from '../assests/img/dashboard-banner.jpg';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Components/sidebar';


function Exhibitorbadges() {
    const [submittedVisitors, setSubmittedVisitors] = React.useState([]);
    const [showThankYou, setShowThankYou] = React.useState(false);
    const [showVisitorForm, setShowVisitorForm] = React.useState(false);
    const [visitorPhotoPreview, setVisitorPhotoPreview] = React.useState(null);
    const visitorPhotoInputRef = React.useRef();
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [customer, setCustomer] = React.useState(null);
    const navigate = useNavigate();

    // Handle form submit
    const handleVisitorFormSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        try {
            const response = await fetch('https://aadikaash.com/backend/wp-json/aadikaash-api/v1/exhibitor_badge', {
                method: 'POST',
                body: formData,
            });
            const result = await response.json();
            if (result.success) {
                setShowThankYou(true);
                setShowVisitorForm(false);
                setVisitorPhotoPreview(null);
                // Refetch badges for this user (use user_id, not email)
                if (
                  customer &&
                  customer.data &&
                  customer.data.customer_details &&
                  customer.data.customer_details.user_id
                ) {
                  fetchExhibitorBadges(customer.data.customer_details.user_id);
                }
            } else {
                alert('Failed to save visitor badge.');
            }
        } catch (err) {
            alert('Error submitting form.');
        }
    };

    // Fetch exhibitor badges for this customer
    const fetchExhibitorBadges = async (user_id) => {
        try {
            const res = await fetch(`https://aadikaash.com/backend/wp-json/aadikaash-api/v1/exhibitor_badge?user_id=${encodeURIComponent(user_id)}`);
            const data = await res.json();
            if (data.success && Array.isArray(data.badges)) {
                // Map backend fields to table fields for display
                const mapped = data.badges.map(badge => ({
                    fullName: badge.full_name || badge.fullName || '',
                    companyName: badge.company_name || badge.companyName || '',
                    address: badge.address || '',
                    city: badge.city || '',
                    pincode: badge.pincode || '',
                    state: badge.state || '',
                    country: badge.country || '',
                    mobile: badge.mobile || '',
                    email: badge.email || '',
                    govtIdNo: badge.govt_id_no || badge.govtIdNo || '',
                    gstin: badge.gstin || '',
                    gstinCert: badge.gstin_cert_url || badge.gstinCert || '',
                    visitorPhoto: badge.visitor_photo_url || badge.visitorPhoto || '',
                    photoId: badge.photo_id_url || badge.photoId || '',
                }));
                setSubmittedVisitors(mapped);
            } else {
                setSubmittedVisitors([]);
            }
        } catch (err) {
            setSubmittedVisitors([]);
        }
    };
    // ...existing code...
    // Webcam capture for desktop (optional, fallback to file input for mobile)
    const handleVisitorPhotoChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            setVisitorPhotoPreview(URL.createObjectURL(file));
        }
    };


    // Fetch customer details and exhibitor badges on mount
    useEffect(() => {
        // Get user credentials from localStorage (set by Login.js)
        const user = localStorage.getItem('user');
        if (!user) {
            setError('No user credentials found. Please login again.');
            setLoading(false);
            navigate('/login');
            return;
        }
        let credentials;
        try {
            credentials = JSON.parse(user);
        } catch (e) {
            setError('Corrupted user credentials. Please login again.');
            setLoading(false);
            localStorage.removeItem('user');
            navigate('/login');
            return;
        }
        if (!credentials.user_id || !credentials.password) {
            setError('Incomplete user credentials. Please login again.');
            setLoading(false);
            localStorage.removeItem('user');
            navigate('/login');
            return;
        }
        fetch(`https://aadikaash.com/backend/wp-json/aadikaash-api/v1/customer_details?user_id=${encodeURIComponent(credentials.user_id)}&password=${encodeURIComponent(credentials.password)}`)
            .then(res => res.json())
            .then(data => {
                setCustomer(data);
                setLoading(false);
                // Debug: Show what is being used as user_id
                let badgeUserId = null;
                if (data && data.data && data.data.customer_details) {
                    // Prefer user_id if available, else fallback to email
                    badgeUserId = data.data.customer_details.user_id || data.data.customer_details.email;
                    console.log('Fetching exhibitor badges for user_id:', badgeUserId);
                    fetchExhibitorBadges(badgeUserId);
                }
            })
            .catch(err => {
                setError('Failed to fetch customer details');
                setLoading(false);
            });
    }, []);

    const handleLogout = () => {
        try {
            localStorage.removeItem('user');
            alert('You have been logged out successfully!');
            // Use setTimeout to ensure navigation after alert
            setTimeout(() => {
                navigate('/login', { replace: true });
            }, 100);
        } catch (error) {
            console.error('Logout failed:', error);
            alert('An error occurred during logout. Please try again.');
        }
    };

    return (
        <div>
            <Header />
            <div className="container dashboard-container">
                {/* Debug output for troubleshooting */}
                  <div className='dashboard-banner'>
                            <img src={dashboardBanner} className='responsive' alt="Dashboard Banner" />
                        </div>
                {error && <pre style={{color:'red'}}>Error: {error}</pre>}
               
                {loading ? (
                    <div>Loading customer details...</div>
                ) : error ? (
                    <div style={{color: 'red'}}>{error}</div>
                ) : customer && customer.status && customer.data && customer.data.customer_details ? (
                    <>
                        <div className='row'>
                            <div className='welcome-user col-md-12 d-flex justify-content-between align-items-center'>
                                <h1>Welcome {customer.data.customer_details.display_name || 'User'}</h1>
                                <ul>                                  
                                    <li> <button onClick={handleLogout} className="logout-btn btn btn-primary btn-sm">Logout</button></li>
                                </ul>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'>
                               <Sidebar />
                            </div>
                            <div className='col-md-9 content-area'>
                                <div className='welcome-page personal-info-box'>
                                    <h2>Exhibitor Badges</h2>
                                    <p>We have already provide you 5 Exhibitor Passes. which is absolutely free of charge. But if you need additional passes, there will be a nominal fee. 500 Rs. Per Pass</p>
                                    <p>If you still need passes, Please  <a className='btn-link' onClick={() => setShowVisitorForm(true)}> click here</a> to create passes.</p>
                                    <i className='text-danger'>Note: Charges of passes will be added in your final settlement Amount</i>

                                    {showVisitorForm && (
                                        <div className="visitor-form-modal" style={{background:'#fff',border:'1px solid #ccc',padding:24,borderRadius:8,boxShadow:'0 2px 8px #0002',marginBottom:24}}>
                                            <form onSubmit={handleVisitorFormSubmit}>
                                                {/* Hidden user_id field for backend association */}
                                                <input type="hidden" name="user_id" value={customer.data.customer_details.user_id} />
                                                <div className="mb-2">
                                                    <label>Full Name</label>
                                                    <input type="text" className="form-control" name="fullName" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Organization / Company Name</label>
                                                    <input type="text" className="form-control" name="companyName" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Address</label>
                                                    <input type="text" className="form-control" name="address" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>City</label>
                                                    <input type="text" className="form-control" name="city" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Pincode</label>
                                                    <input type="text" className="form-control" name="pincode" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>State</label>
                                                    <input type="text" className="form-control" name="state" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Country</label>
                                                    <input type="text" className="form-control" name="country" value="India" readOnly />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Mobile Number</label>
                                                    <input type="text" className="form-control" name="mobile" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Email ID</label>
                                                    <input type="email" className="form-control" name="email" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Government Authorised ID Card No.</label>
                                                    <input type="text" className="form-control" name="govtIdNo" required />
                                                </div>
                                                <div className="mb-2">
                                                    <label>GSTIN No.</label>
                                                    <input type="text" className="form-control" name="gstin" />
                                                </div>
                                                <div className="mb-2">
                                                    <label>GSTIN Certificate (PDF/JPG)</label>
                                                    <input type="file" className="form-control" name="gstinCert" accept=".pdf,.jpg,.jpeg,.png" />
                                                </div>
                                                <div className="mb-2">
                                                    <label>Visitor Photo (JPG/PDF)</label>
                                                    {/* For mobile, capture attribute opens camera. For desktop, allow file selection. */}
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="visitorPhoto"
                                                        accept="image/*,.pdf"
                                                        capture="environment"
                                                        ref={visitorPhotoInputRef}
                                                        onChange={handleVisitorPhotoChange}
                                                    />
                                                    <div style={{marginTop:8}}>
                                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => visitorPhotoInputRef.current && visitorPhotoInputRef.current.click()}>
                                                            Take Photo / Upload
                                                        </button>
                                                    </div>
                                                    {visitorPhotoPreview && (
                                                        <div style={{marginTop:8}}>
                                                            <img src={visitorPhotoPreview} alt="Preview" style={{maxWidth:120, maxHeight:120, border:'1px solid #ccc', borderRadius:4}} />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="mb-2">
                                                    <label>Valid Photo ID (PDF/JPG)</label>
                                                    <input type="file" className="form-control" name="photoId" accept=".pdf,.jpg,.jpeg,.png" />
                                                </div>
                                                <div className="mb-2 d-flex justify-content-between">
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                    <button type="button" className="btn btn-secondary" onClick={() => setShowVisitorForm(false)}>Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                    {/* Show thank you and table after submit */}
                                    {showThankYou && (
                                        <div className="mt-4" style={{background:'#e6ffe6',border:'1px solid #b2ffb2',padding:16,borderRadius:8}}>
                                            <h4>Thank you for submitting the visitor badge form!</h4>
                                        </div>
                                    )}
                                    {/* Debug: Show raw submittedVisitors for troubleshooting */}
                                    <div className="mt-2 d-none">
                                        <pre style={{background:'#f8f8f8', color:'#333', fontSize:12, padding:8, border:'1px solid #eee', borderRadius:4, maxHeight:200, overflow:'auto'}}>Raw: {JSON.stringify(submittedVisitors, null, 2)}</pre>
                                    </div>
                                    <div className="mt-4">
                                        <h5>You have submitted the following exhibitor Passes:</h5>
                                        <div style={{overflowX:'auto'}}>
                                            <table className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Full Name</th>
                                                        <th>Company Name</th>
                                                        <th>Address</th>
                                                        <th>City</th>
                                                        <th>Pincode</th>
                                                        <th>State</th>
                                                        <th>Country</th>
                                                        <th>Mobile</th>
                                                        <th>Email</th>
                                                        <th>Govt ID No</th>
                                                        <th>GSTIN No</th>
                                                        <th>GSTIN Cert</th>
                                                        <th>Photo ID</th>
                                                        <th>Visitor Photo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {submittedVisitors.length === 0 ? (
                                                        <tr><td colSpan={14} style={{textAlign:'center'}}>No visitor badges submitted yet.</td></tr>
                                                    ) : (
                                                        submittedVisitors.map((v, idx) => (
                                                            <tr key={idx}>
                                                                <td>{v.fullName}</td>
                                                                <td>{v.companyName}</td>
                                                                <td>{v.address}</td>
                                                                <td>{v.city}</td>
                                                                <td>{v.pincode}</td>
                                                                <td>{v.state}</td>
                                                                <td>{v.country}</td>
                                                                <td>{v.mobile}</td>
                                                                <td>{v.email}</td>
                                                                <td>{v.govtIdNo}</td>
                                                                <td>{v.gstin}</td>
                                                                <td>{v.gstinCert && (v.gstinCert.startsWith('http') ? <a href={v.gstinCert} target="_blank" rel="noopener noreferrer">View</a> : v.gstinCert)}</td>
                                                                <td>{v.photoId && (v.photoId.startsWith('http') ? <a href={v.photoId} target="_blank" rel="noopener noreferrer">View</a> : v.photoId)}</td>
                                                                <td>{v.visitorPhoto && v.visitorPhoto.startsWith('http') ? <img src={v.visitorPhoto} alt="Visitor" style={{maxWidth:60,maxHeight:60,border:'1px solid #ccc',borderRadius:4}} /> : ''}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                  
                                  
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
            <Footer />
        </div>
    );
}

export default Exhibitorbadges;
